import { connectToBrand_api } from 'api/brandApi';
import Loader from 'elements/Loader';
import useBrand, { BrandExistsState } from 'Hooks/useBrand';
import { CSSProperties, useEffect, useState } from 'react';
import { toast } from 'react-toastify';

export default function TiktokCallbackPage() {
    const { currentBrand } = useBrand() as BrandExistsState
    const [isSuccess, setIsSuccess] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState<string | null>(null);

    useEffect(() => {
        if (isSuccess || errorMessage) {
            setTimeout(() => {
                window.close();
            }, 3000);
        }
    }, [isSuccess, errorMessage]);

    const handleTikTokAuth = async (authCode: string) => {
        try {
            setIsLoading(true);
            await connectToBrand_api({
                brandId: currentBrand?.id,
                brandSlug: currentBrand?.slug,
                value: { code: authCode },
                service: 'tiktok_auth'
            });
            setIsSuccess(true);
        } catch (error) {
            console.error('Error authenticating with TikTok', error);
            setErrorMessage('Failed to connect your TikTok account. Please try again.');
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const code = urlParams.get('auth_code');

        if (code) {
            handleTikTokAuth(code);
        } else {
            toast.error('No authorization code found. Please try again.');
            window.close();
        }
    }, []);


    let content = 'Connecting your TikTok account...';
    if (isSuccess) {
        content = 'TikTok account connected successfully!';
    } else if (errorMessage) {
        content = errorMessage;
    }

    return (
        <div style={sty.container}>
            <Loader />
            <p>{content}</p>
        </div>
    );
}


const sty: Record<string, CSSProperties> = {
    container: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 16,
        padding: 24
    }
};